import React from "react";
import { Field, Dropdown, Option, Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import "../../CSS/IaAgent.css";

const PERSONALITIES = [
  { value: "friendly-casual", labelKey: "PERSONALITY_FRIENDLY_CASUAL" },
  { value: "friendly-professional", labelKey: "PERSONALITY_FRIENDLY_PROFESSIONAL" },
  { value: "formal", labelKey: "PERSONALITY_FORMAL" },
];

const STYLES = [
  { value: "formal-polite", labelKey: "STYLE_FORMAL_POLITE" },
  { value: "casual-familiar", labelKey: "STYLE_CASUAL_FAMILIAR" },
];

export default function PersonalityTab({ agentData, updateField }) {
  const { t } = useTranslation();
  const personality = agentData.agentPersonality || {};

  return (
    <div className="ia-agent-tab">
      <Field label={t("PERSONALITY_LABEL")} className="field-style" required>
        <Dropdown
          value={personality.personality ? t(PERSONALITIES.find((p) => p.value === personality.personality)?.labelKey || "") : ""}
          selectedOptions={personality.personality ? [personality.personality] : []}
          onOptionSelect={(_, d) => updateField("agentPersonality.personality", d.optionValue)}
          placeholder={t("SELECT_PERSONALITY")}
        >
          {PERSONALITIES.map((p) => (
            <Option key={p.value} value={p.value} text={t(p.labelKey)}>
              {t(p.labelKey)}
            </Option>
          ))}
        </Dropdown>
      </Field>

      <Field label={t("LANGUAGE_STYLE_LABEL")} className="field-style" required>
        <Dropdown
          value={personality.languageStyle ? t(STYLES.find((s) => s.value === personality.languageStyle)?.labelKey || "") : ""}
          selectedOptions={personality.languageStyle ? [personality.languageStyle] : []}
          onOptionSelect={(_, d) => updateField("agentPersonality.languageStyle", d.optionValue)}
          placeholder={t("SELECT_LANGUAGE_STYLE")}
        >
          {STYLES.map((s) => (
            <Option key={s.value} value={s.value} text={t(s.labelKey)}>
              {t(s.labelKey)}
            </Option>
          ))}
        </Dropdown>
      </Field>

      <Text className="ia-agent-hint">{t("PERSONALITY_TAB_HINT")}</Text>
    </div>
  );
}
